import { render, staticRenderFns } from "./AddDemoAccountModal.vue?vue&type=template&id=5226777a"
import script from "./AddDemoAccountModal.vue?vue&type=script&lang=js"
export * from "./AddDemoAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports